@if (auth.getUserId()) {
    <img [src]="imageUrl" class="h-10 w-10 rounded-full ring-2 ring-white" alt="profile picture" onerror="this.src = '/assets/image/user-128.svg'" />
} @else {
    <div class="flex h-10 w-10 items-center justify-center rounded-full border-2 border-white">
        <i class="fa-regular fa-user text-xl"></i>
    </div>
}
